import 'react-datepicker/dist/react-datepicker.css';
import { CalendarIcon } from '@village/icons';
import { Input } from '@village/ui';
import { isValid, differenceInDays } from 'date-fns';
import { useBooking, useCaptureCountlyEvent, useIsMobile } from 'hooks';
import { FC, useCallback } from 'react';
import { DatePickerProps } from 'react-datepicker';
import ReactDatePicker from 'react-datepicker';
import { formatDate } from 'utils/date';

import * as Styled from './styles';

const BookingDate: FC<Omit<DatePickerProps, 'onChange' | 'selectsRange'>> = (props) => {
    const isMobile = useIsMobile();
    const { setBookingField, booking } = useBooking();
    const { date, department, reason } = booking;
    const { addCountlyEvent } = useCaptureCountlyEvent();

    const handleCalendarOpen = () => {
        addCountlyEvent({ key: 'changeDate', segmentation: { changeDateType: 'datepicker' } });
    };

    const handleDateChange = useCallback(
        (dateNew: Date | null) => {
            if (dateNew && isValid(dateNew) && differenceInDays(dateNew, new Date()) < 360) {
                setBookingField({ date: dateNew });
            }
        },
        [setBookingField]
    );

    const formattedDate = formatDate(date, 'monthDayShort');

    const customProps = isMobile
        ? {
              customInput: (
                  <div>
                      <Styled.MobileDatePickerButton startIcon={<CalendarIcon />} variant="tertiary" size="medium">
                          {formattedDate}
                      </Styled.MobileDatePickerButton>
                  </div>
              ),
              portalId: 'root-portal',
              withPortal: true,
          }
        : {
              customInput: <Input style={{ textAlign: 'start' }} type={'text'} fullWidth={true} />,
              closeScroll: true,
          };

    return (
        <Styled.Container>
            {!isMobile ? (
                <Styled.Label type="caption1" tag="label">
                    Date:
                </Styled.Label>
            ) : null}
            <ReactDatePicker
                {...props}
                onCalendarOpen={handleCalendarOpen}
                dateFormat="MM/dd/yyyy"
                disabled={!department || !reason}
                minDate={new Date()}
                selected={date}
                onChange={handleDateChange}
                {...customProps}
                id="select-date"
                selectsRange={undefined}
                selectsMultiple={undefined}
                showMonthYearDropdown={undefined}
                className="date-picker"
            />
        </Styled.Container>
    );
};

export { BookingDate };
